/** @format */

// import {filter} from 'lodash';
import React, { useState, useEffect } from "react";
// material
import { Button, Card, Stack, Typography, CardContent } from "@mui/material";
// components
import Page from "../../components/Page";
//
import { useNavigate } from "react-router-dom";
import Iconify from "../../components/Iconify";

// import qs from "qs"
import { useLocation } from "react-router";
import { Row, Col } from "react-bootstrap";
import moment from "moment";
import Countdown from "react-countdown";

// import MenuItem from "@mui/material/MenuItem";

import Select from "react-select";

import textFormatter from "../../utils/TextFormatter";

import bniLogo from "../../assets/bank/bni.png";
import mandiriLogo from "../../assets/bank/mandiri.png";
import bcaLogo from "../../assets/bank/bca.png";
import briLogo from "../../assets/bank/bri.png";

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function BillingReviewOrder(props) {
  const navigate = useNavigate();
  // const location = useLocation();

  const maxPaymentDate = new Date().getTime() + 10800000;

  const { state } = useLocation();

  // const queryParams = qs.parse(location.search, {ignoreQueryPrefix: true});
  // const [accountNumber, setAccountNumber] = useState(88888082113768550)
  const [accountNumber] = useState(88888082113768550);

  const getLogo = () => {
    if (paymentMethod === "BNI") {
      return bniLogo;
    }
    if (paymentMethod === "MANDIRI") {
      return mandiriLogo;
    }
    if (paymentMethod === "BCA") {
      return bcaLogo;
    }
    if (paymentMethod === "BRI") {
      return briLogo;
    }
  };

  useEffect(() => {
    if (!state) {
      navigate("/credits");
    }
    // navigate("/credits")
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!state) {
    return <></>;
  }

  const {
    amountPurchase,
    contactName,
    contactEmail,
    contactCompany,
    contactAddress,
    paymentMethod,
    phoneNumber,
    wabaId,
  } = state; // Read values passed on state

  return (
    <Page title="Purchase">
      {/*<div style={{width : "100%", background : "olive", height :2}}> </div>*/}
      <div style={{ width: "100%", margin: 0, padding: 30, height: "100%" }}>
        <Row>
          <Col md={12}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <div
                onClick={() => {
                  navigate("/purchase/create/" + wabaId, {
                    state: {
                      amountPurchase,
                      contactName,
                      contactEmail,
                      contactCompany,
                      contactAddress,
                      paymentMethod,
                      phoneNumber,
                      wabaId,
                    },
                  });
                }}
                style={{
                  cursor: "pointer",
                }}
              >
                <Iconify
                  width={60}
                  height={60}
                  color={"#DBDBDB"}
                  icon="ion:arrow-back-circle"
                  sx={{ marginRight: 1 }}
                />
              </div>

              <Stack direction="column" justifyContent="center">
                <Typography variant="h4">Purchase</Typography>
              </Stack>
            </div>

            <div style={{ width: 300 }}>
              <Select
                isDisabled={true}
                onChange={(option) => {
                  // console.log(option);
                  // setSelectedWabaId(option.value)
                  // setSelectedWabaLabel(option.label)
                }}
                value={{
                  label: phoneNumber.label,
                  value: phoneNumber.value,
                }}
              />
            </div>

            <Card style={{ marginTop: 10 }}>
              <CardContent>
                <div
                  style={{
                    weight: "bold",
                    color: "black",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <h5 style={{ marginBottom: 0, paddingBottom: 0 }}>
                    Review Order
                  </h5>
                </div>
                <div
                  style={{
                    height: 1,
                    width: "100%",
                    marginTop: 5,
                    marginBottom: 5,
                    backgroundColor: "lightgray",
                  }}
                ></div>

                <Row style={{ marginTop: 15, fontSize: "0.9em" }}>
                  <Col md={6}>
                    <Card style={{ height: "100%" }}>
                      <CardContent
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          height: "100%",
                        }}
                      >
                        <div style={{ flex: 1 }}>
                          <h5 style={{ marginBottom: 0, paddingBottom: 0 }}>
                            Summary Purchase
                          </h5>
                          <div
                            style={{
                              marginTop: 10,
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <div
                              style={{
                                fontSize: "0.9em",
                                color: "grey",
                                flex: 1,
                              }}
                            >
                              Credits
                            </div>
                            <div style={{ fontSize: "0.9em", color: "grey" }}>
                              <b>
                                {textFormatter.moneyFormatter(amountPurchase)}
                              </b>
                            </div>
                          </div>
                          <div
                            style={{
                              marginTop: 5,
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <div
                              style={{
                                fontSize: "0.9em",
                                color: "grey",
                                flex: 1,
                              }}
                            >
                              Tax (11%)
                            </div>
                            <div style={{ fontSize: "0.9em", color: "grey" }}>
                              <b>
                                {textFormatter.moneyFormatter(
                                  Math.round(amountPurchase * 0.11)
                                )}
                              </b>
                            </div>
                          </div>
                          <div
                            style={{
                              height: 1,
                              width: "100%",
                              marginTop: 10,
                              marginBottom: 10,
                              backgroundColor: "lightgray",
                            }}
                          ></div>
                          <div
                            style={{
                              marginTop: 5,
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <div style={{ fontSize: "0.9em", flex: 1 }}>
                              <b>Total Amount</b>
                            </div>
                            <div style={{ fontSize: "0.9em" }}>
                              <b>
                                {textFormatter.moneyFormatter(
                                  Math.round(amountPurchase * 1.11)
                                )}
                              </b>
                            </div>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              color: "grey",
                              alignItems: "flex-start",
                            }}
                          >
                            <b
                              style={{
                                fontSize: "1.1em",
                                marginTop: 30,
                                marginBottom: 10,
                              }}
                            >
                              Contact Information
                            </b>

                            <b>Zeman Mustohid</b>
                            <div>zaemanmustohid21@gmail.com</div>
                            <div>PT. Infomedia Nusantara</div>
                            <div>Jl. Fatmawati Jakarta Selatan</div>

                            <b style={{ fontSize: "1.1em", marginTop: 30 }}>
                              Payment Method
                            </b>
                            <div style={{ fontSize: "0.85em" }}>
                              Virtual Account
                            </div>
                            <img
                              style={{ objectFit: "contain", height: 50 }}
                              src={getLogo()}
                              alt={"logo2"}
                            />
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  </Col>
                  <Col md={6}>
                    <Card>
                      <CardContent
                        style={{ display: "flex", flexDirection: "column" }}
                      >
                        <div style={{ flex: 1 }}>
                          <h5 style={{ marginBottom: 0, paddingBottom: 0 }}>
                            Transfer to {paymentMethod} Virtual Account
                          </h5>
                          <Row style={{ marginTop: 20 }}>
                            <Col md={6}>
                              <img
                                style={{ objectFit: "contain", height: 50 }}
                                src={getLogo()}
                                alt={"logo3"}
                              />
                            </Col>
                            <Col
                              style={{
                                textAlign: "right",
                                fontSize: "2em",
                                fontWeight: 500,
                                display: "flex",
                                alignItems: "flex-end",
                                justifyContent: "flex-end",
                              }}
                              md={6}
                            >
                              {textFormatter.moneyFormatter(
                                Math.round(amountPurchase * 1.11)
                              )}
                            </Col>
                          </Row>
                          <div
                            style={{
                              height: 1,
                              width: "100%",
                              marginTop: 10,
                              marginBottom: 10,
                              backgroundColor: "lightgray",
                            }}
                          ></div>
                          <div
                            style={{
                              marginTop: 5,
                              display: "flex",
                              flexDirection: "row",
                              fontWeight: 400,
                              fontSize: "1.05em",
                            }}
                          >
                            <div style={{ flex: 1 }}>
                              <b>Account Number</b>
                            </div>
                            <div>{accountNumber}</div>
                            <Iconify
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                navigator.clipboard.writeText(accountNumber);
                              }}
                              width={"1.5em"}
                              height={"1.5em"}
                              color={"#62707f"}
                              icon="ph:copy-fill"
                              sx={{ marginLeft: 1 }}
                            />
                          </div>
                          <div
                            style={{
                              marginTop: 5,
                              display: "flex",
                              flexDirection: "row",
                              fontWeight: 400,
                              fontSize: "1.05em",
                              justifyContent: "center",
                            }}
                          >
                            <div style={{ flex: 1 }}>
                              <b>Name</b>
                            </div>
                            <div>PT Infomedia Nusantara</div>
                            <Iconify
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                navigator.clipboard.writeText(
                                  "PT Infomedia Nusantara"
                                );
                              }}
                              width={"1.5em"}
                              height={"1.5em"}
                              color={"#62707f"}
                              icon="ph:copy-fill"
                              sx={{ marginLeft: 1 }}
                            />
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                    <Card style={{ marginTop: 15 }}>
                      <CardContent>
                        <h6>
                          Please complete payment before:{" "}
                          {moment(maxPaymentDate).format("DD MMM YYYY")}{" "}
                          {moment(maxPaymentDate).format("HH:mm:ss")}
                        </h6>
                        <br />
                        <small>Time Remaining : </small>
                        <h5>
                          <Countdown daysInHours={true} date={maxPaymentDate} />
                        </h5>
                      </CardContent>
                    </Card>
                    <div style={{ marginTop: 20, fontSize: "1.1em" }}>
                      Any Problem about payment?&nbsp;&nbsp;
                      <a
                        target={"_blank"}
                        href={`https://api.whatsapp.com/send/?phone=6282113768550&text=Halo+Support,+Saya+ada+kendala+pada+nomor+whatsapp+${phoneNumber.value}+dengan+no+pembayaran+virtual+account+sebagai+berikut+${accountNumber}`}
                        rel="noreferrer"
                      >
                        <Button
                          style={{
                            borderColor: "gray",
                            color: "gray",
                            fontSize: "0.657em",
                          }}
                          size="small"
                          variant={"outlined"}
                        >
                          Contact Us
                        </Button>
                      </a>
                    </div>
                  </Col>
                </Row>
              </CardContent>
            </Card>
          </Col>
        </Row>
      </div>
    </Page>
  );
}
